import React, {useEffect} from 'react';
import {Text} from '@gravity-ui/uikit';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {useDeleteFundraiserDocument} from '../../lib';

interface DeleteFundraiserDocumentModalProps {
  open: boolean;
  onClose: () => void;
  appealId: string;
  documentId: string;
}

export const DeleteFundraiserDocumentModal = ({
  open,
  onClose,
  appealId,
  documentId,
}: DeleteFundraiserDocumentModalProps) => {
  const {deleteDocumentMutation} = useDeleteFundraiserDocument(appealId);

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Удаление документа',
    title: 'Ошибка при удалении документа',
  });

  useEffect(() => {
    if (deleteDocumentMutation.error) {
      handleError(deleteDocumentMutation.error as unknown as ApiError);
    }
  }, [deleteDocumentMutation.error, handleError]);

  const handleSubmit = () => {
    deleteDocumentMutation.mutate(
      {documentId},
      {
        onSuccess: () => {
          onClose();
        },
      },
    );
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={onClose}
        setOpen={() => onClose()}
        submitForm={handleSubmit}
        isLoading={deleteDocumentMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление документа'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить документ?
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
